import { getRequest } from "./request-interceptor.service"

export const fetchPublicPlans = async () => {
  return await getRequest('/users/public-plans');
}